import React, { useEffect } from 'react'
import { useStoreActions } from 'easy-peasy'
import { useHistory, useParams } from 'react-router-dom'
import clsx from 'clsx'
import queryString from 'query-string'
import { Tabs } from 'antd'

import Overview from './Overview'
import SegmentList from './SegmentList'
import CustomerList from './CustomerList'
import '../index.scss'

const TABS = [
  { value: 'overview', label: 'Audience Overview', component: Overview },
  { value: 'segment_listing', label: 'Segment Listing', component: SegmentList },
  { value: 'customer_listing', label: 'Audience Listing', component: CustomerList },
]

const CustomersAnalytics = () => {
  const history = useHistory()
  const queryObject = queryString.parse(history.location.search)
  const { setBreadCrumb } = useStoreActions((actions: any) => actions.breadcrumb)

  const onTabClick = (tab: string) => {
    history.push({ search: queryString.stringify({ ...queryObject, tab }) })
  }

  useEffect(() => {
    setBreadCrumb([{ title: 'Audience', path: '/analytics/customers' }])
  }, [setBreadCrumb])

  return (
    <div className="px-8 py-7 w-full" style={{ minHeight: 1000 }}>
      <span className="text-3xl font-semibold">Audience Analytics</span>
      <div className="mt-8 w-full">
        <Tabs
          destroyInactiveTabPane
          activeKey={
            !TABS.some((tab) => tab.value === queryObject?.tab)
              ? 'overview'
              : queryObject?.tab?.toString()
          }
        >
          {TABS.map(({ component: Component, ...tab }) => (
            <Tabs.TabPane
              key={tab.value}
              tabKey={tab.value}
              tab={
                <span
                  className={clsx(
                    'font-semibold text-secondary_text',
                    tab.value === queryObject?.tab?.toString() && 'text-black'
                  )}
                  onClick={() => onTabClick(tab.value)}
                >
                  {tab.label}
                </span>
              }
            >
              <div className="my-4">
                <Component />
              </div>
            </Tabs.TabPane>
          ))}
        </Tabs>
      </div>
    </div>
  )
}

export default CustomersAnalytics
